import appReducer from "./app/reducer";

export default {
  app: appReducer,
};
